module.exports = __webpack_public_path__ + "static/headshot-ted-reed.586045dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-ted-reed.jpg
// module id = 143
// module chunks = 35783957827783 152909308826437